import Error from '../assets/icons/Error';
import Warning from '../assets/icons/Warning';
import styles from '../styles/widget.module.css';

export type AlertMessageType = 'warning' | 'error';

interface AlertProps {
  type?: AlertMessageType;
  title?: string;
  description?: string;
  onClose?: () => void;
  className?: string;
}

export const AlertMessage: React.FC<AlertProps> = ({
  type = 'error',
  title,
  description,
  onClose,
  className,
}) => {
  const isWarning = type === 'warning';

  return (
    <div
      className={`
        ${styles.alertMessageWrapper}
        ${isWarning ? styles.alertTypeWarning : styles.alertTypeError}
        ${className ?? ''}
      `}
      role="alert-message"
    >
      <div className={styles.icon}>
        {isWarning ? (
          <Warning />
        ) : (
          <Error />
        )}
      </div>

      <div className={styles.content}>
        <span className={styles.title}>{title}</span>

        {description && (
          <p className={styles.description}>{description}</p>
        )}
      </div>

      {onClose && (
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close alert"
        >
          ✕
        </button>
      )}
    </div>
  );
};